import Auslandsversandkosten from 'src/pages/Auslandsversandkosten/Auslandsversandkosten'
import { getSitePageBuilderStaticProps } from 'src/pageBuilder/sitePageBuilder'

export default Auslandsversandkosten

export const getStaticProps = getSitePageBuilderStaticProps
